export default "__VITE_ASSET__38768090__"